import Main from "../components/Main";
import Specials from "../components/Specials";
import Testimonials from "../components/Testimonials";
import RestaurantStory from "../components/RestaurantStory";
const Home = () => {
  return (
    <>
      <Main />
      <Specials />
      <Testimonials />
      <RestaurantStory />
    </>
  );
};
export default Home